import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { Brand } from '../../interfaces/Brand/Brand';
import { getBrands } from '../../api/Brand';
import { sharedColors } from '../../utils/Style';

interface BrandDropdownProps {
  label?: string;
  brandID?: number;
  onChange: (id?: number) => void;
}

export const BrandDropdown = (props: BrandDropdownProps) => {
  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState<Brand[]>([]);

  useEffect(() => {
    setLoading(true);
    getBrands()
      .then((b) => setBrands(b))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
        width: '100%',
      }}
    >
      <FormControl size='small' fullWidth>
        {!!props.label && <InputLabel>{props.label}</InputLabel>}
        <Select
          label={props.label}
          value={props.brandID?.toString() ?? 'NONE'}
          onChange={(e) => {
            const s = e.target.value;
            props.onChange(!!s && s !== 'NONE' ? Number(s) : undefined);
          }}
        >
          <MenuItem value='NONE'>
            <Typography sx={{ fontStyle: 'italic', color: sharedColors.gray5 }}>
              {'<YOK>'}
            </Typography>
          </MenuItem>
          {brands.map((brand) => (
            <MenuItem key={brand.id} value={brand.id.toString()}>
              {brand.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {loading && <CircularProgress size={24} />}
    </Box>
  );
};
